import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './IconWrap.scss';
export var IconSize;
(function (IconSize) {
    IconSize["NANO"] = "nano";
    IconSize["TINY"] = "tiny";
    IconSize["SMALL"] = "small";
    IconSize["COMPACT"] = "compact";
    IconSize["MEDIUM"] = "medium";
    IconSize["BIG"] = "big";
    IconSize["HUGE"] = "huge";
    IconSize["MEGA"] = "mega";
})(IconSize || (IconSize = {}));
export var IconPixelSize;
(function (IconPixelSize) {
    IconPixelSize[IconPixelSize["NANO"] = 8] = "NANO";
    IconPixelSize[IconPixelSize["TINY"] = 12] = "TINY";
    IconPixelSize[IconPixelSize["SMALL"] = 18] = "SMALL";
    IconPixelSize[IconPixelSize["COMPACT"] = 20] = "COMPACT";
    IconPixelSize[IconPixelSize["MEDIUM"] = 24] = "MEDIUM";
    IconPixelSize[IconPixelSize["BIG"] = 36] = "BIG";
    IconPixelSize[IconPixelSize["HUGE"] = 48] = "HUGE";
    IconPixelSize[IconPixelSize["MEGA"] = 96] = "MEGA";
})(IconPixelSize || (IconPixelSize = {}));
var IconWrap = /** @class */ (function (_super) {
    __extends(IconWrap, _super);
    function IconWrap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconWrap.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.size, size = _b === void 0 ? IconSize.MEDIUM : _b, _c = _a.withPadding, withPadding = _c === void 0 ? false : _c, condensed = _a.condensed, _d = _a.customSizable, customSizable = _d === void 0 ? false : _d, children = _a.children, verticalAlign = _a.verticalAlign, disableDefaultColors = _a.disableDefaultColors, ariaHidden = _a["aria-hidden"], ariaLabel = _a["aria-label"], onAnimationEnd = _a.onAnimationEnd, containerRef = _a.containerRef;
        return (React.createElement("span", { className: classnames(s['root'], !customSizable && s[size], withPadding && s['withPadding'], condensed && s['condensed'], verticalAlign && s["vertical-align-" + verticalAlign], !disableDefaultColors && s['default-colors'], className), "aria-hidden": ariaHidden, "aria-label": ariaLabel, onAnimationEnd: onAnimationEnd, ref: containerRef }, children));
    };
    return IconWrap;
}(React.Component));
export { IconWrap };
export default IconWrap;
//# sourceMappingURL=IconWrap.js.map